import { Alert, Button, Modal } from '@printdeal/ui-library';
import React from 'react';
import {
  FormattedMessage, useIntl,
} from 'react-intl';

interface ExtendQuoteSuccessModalProps {
  handleCloseModal: (eventName: string) => void;
}

const ExtendQuoteSuccessModal = ({ handleCloseModal }: ExtendQuoteSuccessModalProps) => {
  const intl = useIntl();

  return (
    <Modal
      isOpen
      onClose={() => handleCloseModal('modal_extend_quote_close')}
      dismissLabel={intl.formatMessage({
        id: 'account.general.modal.close',
        defaultMessage: 'Close',
      })}
      title={intl.formatMessage({
        id: 'ineItems.list.extendQuote.title',
        defaultMessage: 'Extend Quote',
      })}
    >
      <Modal.Content>
        <Alert variant="success">
          <FormattedMessage
            id="quotes.created.success"
            defaultMessage="Your offer has been requested! you will receive a response from us within 24 hours on info@drukwerkdeal.nl"
          />
        </Alert>
      </Modal.Content>
      <Modal.Footer
        className="pd-flex pd-flex-row-reverse pd-flex-wrap pd-gap-2"
      >
        <Button variant="secondary" onClick={() => handleCloseModal('modal_extend_quote_close')}>
          <FormattedMessage
            id="account.order.service.any.modal.footer.close"
            defaultMessage="Close"
          />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExtendQuoteSuccessModal;
